export interface AgentSettingConfig {
  key: string;
  label: string;
  description: string;
}

export interface IAgentSettingsMenuProps {
  settings: Record<string, boolean>;
  onChange: (settings: Record<string, boolean>) => void;
  disabled?: boolean;
}

// Central config — add new toggles here only
export const AGENT_SETTINGS_CONFIG: AgentSettingConfig[] = [
  {
    key: 'perform_functional_test',
    label: 'App testing',
    description: 'Agent tests your app automatically',
  },
  // Add future settings here, e.g.:
  // { key: 'run_security_scan', label: 'Security scan', description: 'Run OWASP security checks' },
];

export const DEFAULT_AGENT_SETTINGS: Record<string, boolean> = AGENT_SETTINGS_CONFIG.reduce(
  (acc, cfg) => ({ ...acc, [cfg.key]: false }),
  {} as Record<string, boolean>
);
